export default "__VITE_ASSET__Cgbm19aC__"